import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import LoadingSpinner from "./components/LoadingSpinner";
import "./App.css";
import { getOrFetch } from "./utils/apiCache";

function CategoriesPage() {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCategories = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const cats = await getOrFetch(
        "categories:all",
        () =>
          axios
            .get("https://floriakw.com/wp-json/wc/v3/products/categories", {
              auth: {
                username: "ck_39cd5450af63b97a35e502d9a0a75925866fefab",
                password: "cs_15701bd9b4392a3b6e5a3d5fa4d326d7acb0a0bf",
              },
            })
            .then((r) => r.data.filter((cat) => cat.name !== "Uncategorized")),
        { ttlMs: 60 * 60 * 1000 }
      );
      setCategories(cats);
    } catch (err) {
      console.error("Error fetching categories:", err);
      setError("حدث خطأ أثناء تحميل الأقسام. يرجى المحاولة مرة أخرى.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Loading state
  if (isLoading) {
    return (
      <div className="category-page">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">الرئيسية</Link> / <span>أقسام المنتجات</span>
          </nav>
          <div className="loading-container" style={{ minHeight: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <LoadingSpinner size="medium" color="black" withText={true} />
          </div>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="category-page">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">الرئيسية</Link> / <span>أقسام المنتجات</span>
          </nav>
          <div className="error-message">
            <p>{error}</p>
            <button className="retry-button" onClick={fetchCategories}>
              إعادة المحاولة
            </button>
          </div>
        </div>
      </div>
    );
  }

  // No categories state
  if (categories.length === 0) {
    return (
      <div className="category-page">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">الرئيسية</Link> / <span>أقسام المنتجات</span>
          </nav>
          <div className="no-products">
            <p>لا توجد أقسام متاحة حاليًا</p>
          </div>
        </div>
      </div>
    );
  }

  // Success state
  return (
    <div className="category-page">
      <div className="container">
        <nav className="breadcrumb">
          <Link to="/">الرئيسية</Link> / <span>أقسام المنتجات</span>
        </nav>

        <div className="grid category-products">
          {categories.map((cat) => (
            <div key={cat.id} className="product-card">
              <Link to={`/category/${cat.id}`} className="image-wrapper">
                {cat.image ? (
                  <img src={cat.image.src} alt={cat.name} />
                ) : (
                  <div className="no-image">No Image</div>
                )}
              </Link>
              <h3 className="product-title">
                <Link to={`/category/${cat.id}`}>{cat.name}</Link>
              </h3>
              <p className="products-count">{cat.count} منتج</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CategoriesPage;
